import { Button, DropdownSelect, Input } from '@components/common';

interface SuppliersToolbarProps {
  searchQuery: string;
  statusFilter: 'all' | 'active' | 'inactive';
  onSearchChange: (value: string | number) => void;
  onStatusChange: (value: 'all' | 'active' | 'inactive') => void;
  onCreate: () => void;
}

export function SuppliersToolbar({
  searchQuery,
  statusFilter,
  onSearchChange,
  onStatusChange,
  onCreate,
}: SuppliersToolbarProps) {
  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <h3 className="text-lg font-semibold text-gray-900">Suppliers</h3>
          <p className="mt-1 text-sm text-gray-500">
            Maintain the shared supplier list, terms, contacts, and opening
            balances before invoice and payment workflows go live.
          </p>
        </div>
        <Button onClick={onCreate}>Create supplier</Button>
      </div>

      <div className="mt-4 grid gap-4 md:grid-cols-2">
        <Input
          label="Search"
          value={searchQuery}
          onChange={onSearchChange}
          placeholder="Search by supplier, contact, phone, email, or tax ID"
        />
        <DropdownSelect
          label="Status"
          value={statusFilter}
          options={[
            { value: 'all', label: 'All statuses' },
            { value: 'active', label: 'Active' },
            { value: 'inactive', label: 'Inactive' },
          ]}
          onChange={(value) =>
            onStatusChange(value as 'all' | 'active' | 'inactive')
          }
        />
      </div>
    </div>
  );
}
